import Vue from 'vue'
import { URL_TEMPLATES } from '@/constants/urls.js'
import { POSITIONS_TEMPLATE_MANAGEMENT, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [POSITIONS_TEMPLATE_MANAGEMENT.STATE.POSITIONS_TEMPLATE_LIST]: null,
  [POSITIONS_TEMPLATE_MANAGEMENT.STATE.CURRENT_POSITION_TEMPLATE]: null
}

const actions = {
  async [POSITIONS_TEMPLATE_MANAGEMENT.ACTIONS.GET_POSITION_TEMPLATE_LIST] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_TEMPLATES}/${model.lotType}/${model.lotTemplateId}/positions?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(POSITIONS_TEMPLATE_MANAGEMENT.MUTATIONS.GET_POSITION_TEMPLATE_LIST, resp.data)
  },
  async [POSITIONS_TEMPLATE_MANAGEMENT.ACTIONS.GET_POSITION_TEMPLATE_INFO] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_TEMPLATES}/${model.lotType}/${model.lotTemplateId}/positions/${model.positionTemplateId}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(POSITIONS_TEMPLATE_MANAGEMENT.MUTATIONS.GET_POSITION_TEMPLATE_INFO, resp.data)
  },
  async [POSITIONS_TEMPLATE_MANAGEMENT.ACTIONS.CREATE_POSITION_TEMPLATE] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_TEMPLATES}/${model.lotType}/${model.lotTemplateId}/positions/${model.premiumType}`,
      model: model.position
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [POSITIONS_TEMPLATE_MANAGEMENT.ACTIONS.UPDATE_POSITION_TEMPLATE] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_TEMPLATES}/${model.lotType}/${model.lotTemplateId}/positions/${model.premiumType}/${model.positionTemplateId}`,
      model: model.position
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [POSITIONS_TEMPLATE_MANAGEMENT.ACTIONS.DELETE_POSITION_TEMPLATE] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_TEMPLATES}/${model.lotType}/${model.lotTemplateId}/positions/${model.positionTemplateId}`
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.DELETE_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [POSITIONS_TEMPLATE_MANAGEMENT.ACTIONS.CLEAR_POSITION_TEMPLATE_INFO] ({ commit }) {
    commit(POSITIONS_TEMPLATE_MANAGEMENT.MUTATIONS.CLEAR_POSITION_TEMPLATE_INFO)
  },
  async [POSITIONS_TEMPLATE_MANAGEMENT.ACTIONS.CLEAR_POSITION_TEMPLATE_LIST] ({ commit }) {
    commit(POSITIONS_TEMPLATE_MANAGEMENT.MUTATIONS.CLEAR_POSITION_TEMPLATE_LIST)
  }
}

const mutations = {
  [POSITIONS_TEMPLATE_MANAGEMENT.MUTATIONS.GET_POSITION_TEMPLATE_INFO] (state, position) {
    state[POSITIONS_TEMPLATE_MANAGEMENT.STATE.CURRENT_POSITION_TEMPLATE] = position
  },
  [POSITIONS_TEMPLATE_MANAGEMENT.MUTATIONS.GET_POSITION_TEMPLATE_LIST] (state, positions) {
    state[POSITIONS_TEMPLATE_MANAGEMENT.STATE.POSITIONS_TEMPLATE_LIST] = positions
  },
  [POSITIONS_TEMPLATE_MANAGEMENT.MUTATIONS.CLEAR_POSITION_TEMPLATE_INFO] (state) {
    state[POSITIONS_TEMPLATE_MANAGEMENT.STATE.CURRENT_POSITION_TEMPLATE] = null
  },
  [POSITIONS_TEMPLATE_MANAGEMENT.MUTATIONS.CLEAR_POSITION_TEMPLATE_LIST] (state) {
    state[POSITIONS_TEMPLATE_MANAGEMENT.STATE.POSITIONS_TEMPLATE_LIST] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
